import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { BillingExportTypeFilter } from '../../model/billing/billing-export-type-filter';

@Injectable({
  providedIn: 'root'
})
export class BillingExportTypeService {

  constructor( private dataService: DataService ) {}

  private readonly getBillingExportTypeFilterEndPoint: string =
    '/billingExportType/getBillingExportTypeFilter/';

  async getBillingExportTypeFilter( preBillingId: number ):
      Promise<BillingExportTypeFilter[]> {

    const params = { preBillingId };

    return await this.dataService
                     .get<BillingExportTypeFilter[]>
                         (this.getBillingExportTypeFilterEndPoint, params)
                     .toPromise();
  }

}
